export default __webpack_public_path__ + "static/media/pdf.7eec312e.svg";